import React from 'react';
import Portal from '@components/utils/Portal';

import FormSketch from '@mitechnologies/formitize-2.5-canvas';
import '@mitechnologies/formitize-2.5-canvas/dist/style.css';
import styled from '@emotion/styled';

export const EditorScreen = styled.div`
    background-color: rgb(255, 255, 255);
    position: fixed;
	inset: 0px;
	overflow: hidden;
	overscroll-behavior: none;
    flex-direction: column;

    font-size: 12px;
	font-family: 'Outfit', sans-serif;
	height: 100%;
	display: flex;
	flex-grow: 1;
	padding: 0px;
	margin: 0px;
    z-index: 1000901;
`

export default function Component({
    onSaveInvoked,
    onExitInvoked,
    onMount = (e) => {},
    formSketchData,
    displayGrid = true,
    canSave = true,
    canExport = false,
    canExit = true,
    width = 1024,
    height = 1024,
    ...rest
}) {
    const formSketchRef = React.createRef();

    return (
        <>
            <Portal targetId={'react-portal'}>
                <div style={{
                    position: 'fixed',
                    zIndex: 1000900
                }}>
                    <FormSketch
                        screenStyle={{
                            zIndex: 10901
                        }}
                        width={width}
                        onMount={onMount}
                        displayGrid={displayGrid}
                        height={height}
                        canSave={canSave}
                        canExport={canExport}
                        canExit={canExit}
                        canvasData={formSketchData}
                        onExitInvoked={onExitInvoked}
                        onSaveInvoked={onSaveInvoked}
                        {...rest}
                    />
                </div>
            </Portal>
        </>
    )
}